
// This processes the array of translations in tagdata and adds a trans field to each
// item in the array, if a translation is found
export default {
  convertTransArrayToObjects: function (arr) {
    let items = []
    arr.forEach(el => {
      items.push( { tag: el })
    })
    return items
  },
  getTranslation: async function(apix, tag, lang) {
    let tts = [ tag.toLowerCase() ]
    let res = await apix.post('collections/translate', { items: tts, lang: lang })
    let items = res.data.items
    if(items.length > 0) {
      return items[0].trans
    }
    return tag
  },
  getTagTranslations: async function (apix, tagdata, lang) {
    let tts = []
    tagdata.forEach(el => {
      tts.push(el.tag.toLowerCase())
    })
    let res = await apix.post('collections/translate', { items: tts, lang: lang })
    let items = res.data.items
    items.forEach(el => {
      let it = tagdata.find(tag => (tag.tag.toLowerCase() === el.keyword))
      if(it) {
        it.trans = el.trans
      }
    })
  },
}